import React from 'react';
import { X } from './Vectors';

import '../css/ui/YoutubeLightbox.scss';

export default class YoutubeLightbox extends React.Component<{data}>
{
	state = {
		shown: false,
		width: 0,
		height: 0,
		marginLeft: 0,
		marginTop: 0,
	};

	closeBtn;

	private _onResize = () =>
	{
		let w = this.props.data.width;
		let h = this.props.data.height;
		let s = w / h;
		let ww = window.innerWidth || document.body.clientWidth;
		let wh = window.innerHeight|| document.body.clientHeight;
		let aw = ww - 120 * 2;
		let ah = wh - 120 * 2;
		if(aw < 800){
			aw = ww;
			ah = wh;
		}

		if(aw / ah > s)
		{
			s = ah / h;
		}else
		{
			s = aw / w;
		}
		w *= s;
		h *= s;
		let ml = (ww - w) * 0.5;
		let mt = (wh - h) * 0.5;
		this.setState({width: w, height: h, marginLeft: ml, marginTop: mt});
	}

	show()
	{
		window.addEventListener('resize', this._onResize);
		this._onResize();
		this.closeBtn.addEventListener('click', this._closeClick);
		document.body.classList.add('block-scroll');
		this.setState({shown: true});
	}

	hide()
	{
		this.closeBtn.removeEventListener('click', this._closeClick);
		window.removeEventListener('resize', this._onResize);
		document.body.classList.remove('block-scroll');
		this.setState({shown: false});
	}

	private _closeClick = () =>
	{
		this.hide();
	}

	render()
	{
		return (
			<div className={['youtubeLightbox', (this.state.shown?'show':null)].join(' ')}>
				<a ref={r => this.closeBtn = r} className='closeBtn'>
					<X></X>
				</a>
				{
					(this.state.shown)?(<iframe width={this.state.width} height={this.state.height} style={{marginLeft: this.state.marginLeft, marginTop: this.state.marginTop}} src={this.props.data.src}></iframe>):null
				}
			</div>
		)
	}
}